import Text from '@amzn/meridian/text';
import { localizeWithRef } from './localize';

export default localizeWithRef(Text, ['children', 'title']);
